import React, { useEffect, useState } from "react";
import dataProvider from "server/dataProvider";
import { EmployeeServicePath, STAFF_REQUEST, StaffRequestTitles, StaffRequestTypes } from "utils/constants";
import { employeeRequests } from "api/employeeApi";
import { useLocation, useParams } from "react-router";
import { Box } from "@mui/material";
import { ResourceContextProvider, SimpleShowLayout, Title } from "react-admin";
import BackButtonToolbar from "features/BackButtonToolbar";
import SubstitutionRequestsDetails from "./components/SubstitutionRequestsDetails";
import ClassMakeUpsRequestsDetails from "./components/ClassMakeUpsRequestsDetails";
import ApproversSection from "./components/ApproversSection";
import LeaveInfoSection from "./InfoSections/LeaveInfoSection";
import BusinessTripInfoSection from "./InfoSections/BusinessTripInfoSection";
import LeaveActionButtons from "./components/LeaveActionButtons";
import { useNotifyError } from "utils/useNotifyError";

const requestUrlByType = {
  [StaffRequestTypes.ScheduleSubstitution]: employeeRequests.getScheduleSubstitutionRequestById,
  [StaffRequestTypes.ClassesMakeUp]: employeeRequests.getClassMakeUpRequestById,
  [StaffRequestTypes.AnnualLeave]: employeeRequests.getLeaveById,
  [StaffRequestTypes.SickLeave]: employeeRequests.getSickLeaveById,
  [StaffRequestTypes.BusinessTrip]: employeeRequests.getBusinessTripById,
};

const DetailsStaffRequests = () => {
  const { id } = useParams();
  const notifyError = useNotifyError();
  const location = useLocation();
  const type = location?.state?.type;
  const readOnly = location?.state?.readOnly;
  const title = StaffRequestTitles[type] ?? "Заявка";

  const isVacation = type === StaffRequestTypes.AnnualLeave;
  const isLeave = isVacation || type === StaffRequestTypes.SickLeave;
  const isBusinessTrip = type === StaffRequestTypes.BusinessTrip;

  const [record, setRecord] = useState(null);

  const renderInfoSection = () => {
    switch (type) {
      case StaffRequestTypes.ScheduleSubstitution:
        return <SubstitutionRequestsDetails />;
      case StaffRequestTypes.ClassesMakeUp:
        return <ClassMakeUpsRequestsDetails />;
      case StaffRequestTypes.AnnualLeave:
      case StaffRequestTypes.SickLeave:
        return <LeaveInfoSection type={type} />;
      case StaffRequestTypes.BusinessTrip:
        return <BusinessTripInfoSection type={type} />;
      default:
        return null;
    }
  };

  // Leave & business trip get their own action buttons (when editable); only vacation also shows approvers
  const renderFooter = () =>
    isLeave || isBusinessTrip ? (
      <>
        {isVacation && (
          <ApproversSection
            type={type}
            showActions={false}
          />
        )}
        {!readOnly && <LeaveActionButtons type={type} />}
      </>
    ) : (
      <ApproversSection type={type} />
    );

  useEffect(() => {
    const fetchDetails = async () => {
      const buildUrl = requestUrlByType[type];
      if (!buildUrl) return;
      const { data } = await dataProvider.customRequest(buildUrl(id), null, "GET");
      setRecord(data);
    };

    fetchDetails().catch(err => {
      console.error(err);
      notifyError(err);
    });
  }, [id, type, notifyError]);

  return (
    <Box sx={{ width: "100%", overflow: "hidden" }}>
      <Title title={`Детайли ${title}`} />
      <BackButtonToolbar />
      {record && (
        <ResourceContextProvider value={`${EmployeeServicePath}${STAFF_REQUEST}`}>
          <SimpleShowLayout record={record}>
            {renderInfoSection()}
            {renderFooter()}
          </SimpleShowLayout>
        </ResourceContextProvider>
      )}
    </Box>
  );
};

export default DetailsStaffRequests;
